import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ViewSettingsRepository } from '@skylab-angular-shared/business';
import { L10n } from '@skylab-angular-shared/core';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { BooleanValueAccessorDirective, ButtonComponent, DialogContentComponentBase, DialogContentComponentIns, DialogContentViewModel, DialogHeaderComponentIns, DialogInsService, DialogState } from '@skylab-angular-shared/ui';
import { SaleCommunityTransactionSymbol, ViewSettingsRepositoryBase } from '@skylab-shared/business';
import { L10nBase } from '@skylab-shared/core';

export interface DocumentItemVatRateNotAvailableDialogData {
    readonly oldVatRate: string;
    readonly communityTransaction: SaleCommunityTransactionSymbol;
    readonly vatRatesAvailableConfig: boolean | Record<SaleCommunityTransactionSymbol, boolean>;
}

interface DocumentItemVatRateNotAvailableDialogViewModel extends DialogContentViewModel {
    message: string;
    title: string;
    doNotShowAgain: boolean;
}

@Component({
    selector: 'skl-document-item-vat-rate-not-available-dialog',
    templateUrl: './document-item-vat-rate-not-available-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, BooleanValueAccessorDirective, FormsModule, ButtonComponent, TranslatePipe]
})
export class DocumentItemVatRateNotAvailableDialogComponent extends DialogContentComponentBase<DocumentItemVatRateNotAvailableDialogViewModel, DocumentItemVatRateNotAvailableDialogData> {
    public constructor(
        dialogService: DialogInsService,
        @Inject(L10n) private readonly l10n: L10nBase,
        @Inject(ViewSettingsRepository) protected readonly viewSettingsRepository: ViewSettingsRepositoryBase
    ) {
        super(dialogService);
    }

    protected override getInitialState(): DocumentItemVatRateNotAvailableDialogViewModel {
        return {
            ...super.getInitialState(),
            title: this.l10n._T('scenes.shared.document-item-vat-rate-not-available.dialog.title'),
            message: this.l10n.instant('scenes.shared.document-item-vat-rate-not-available.dialog.text', { oldVatRate: this.data.oldVatRate, communityTransaction: this.data.communityTransaction }),
            doNotShowAgain: false
        };
    }

    public async onConfirmAsync(): Promise<void> {
        if (this.viewModel.doNotShowAgain) {
            if (this.data.communityTransaction === 'WSTO-OSS') {
                await this.viewSettingsRepository.saveViewSettingsAsync('sale-oss-vat-rate-not-available-dont-show-again', this.viewModel.doNotShowAgain);
            } else {
                const config = (typeof this.data.vatRatesAvailableConfig === 'object' ? { ...this.data.vatRatesAvailableConfig } : {}) as Record<string, boolean>;
                config[this.data.communityTransaction] = this.viewModel.doNotShowAgain;
                await this.viewSettingsRepository.saveViewSettingsAsync('sale-vat-rate-not-available-dont-show-again', config);
            }
        }
        this.dialogService.close({
            state: DialogState.Confirm,
        });
    }
}
